import { all } from 'redux-saga/effects'

import accessProfileSaga from './accessProfile'
import analitycalDashboardSaga from './analitycalDashboard'
import analitycalPartsSaga from './analitycalParts'
import analitycalSaga from './analitycal'
import biDashboardSaga from './biDashboard'
import billedMonthComparativeSaga from './billedMonthComparative'
import billedSaga from './billed'
import biSellersDashboardSaga from './biSellersDashboard'
import blipSaga from './blip'
import callSaga from './call'
import callsSaga from './calls'
import circularsSaga from './circulars'
import dailyEmails from './dailyEmails'
import dailySalesSaga from './dailySales'
import dashboardSaga from './dashboard'
import dealershipSaga from './dealership'
import dealershipsSaga from './dealerships'
import departmentSaga from './department'
import departmentsSaga from './departments'
import equipmentDashboardSaga from './equipmentDashboard'
import equipmentSaga from './equipment'
import equipmentsSaga from './equipments'
import equipmentsTypesSaga from './equipmentsTypes'
import equipmentTypeSaga from './equipmentType'
import functionSaga from './function'
import functionsSaga from './functions'
import helpdeskDashboardSaga from './helpdeskDashboard'
import ipc from './ipc'
import islands from './islands'
import newsBoardSaga from './newsBoard'
import newsSingle from './newsSingle'
import notificationsSaga from './notifications'
import objectiveSaga from './objective'
import objectivesSaga from './objectives'
import organogramSaga from './organogram'
import panoramasSaga from './panoramas'
import pops from './pops'
import profileSaga from './profile'
import quizzeSaga from './quiz'
import quizzesSaga from './quizzes'
import receipt from './receipt'
import rhDashboardSaga from './rhDashboard'
import rhMonthComparativeSaga from './rhMonthComparative'
import salesGoalsSaga from './salesGoals'
import sellersSaga from './sellers'
import sessionSaga from './session'
import statusListSaga from './statusList'
import statusSaga from './status'
import superiorSaga from './superior'
import superiorsSaga from './superiors'
import surveysSaga from './surveys'
import userSaga from './user'
import usersRamal from './usersRamal'
import usersSaga from './users'

export default function* rootSaga() {
  yield all([
    accessProfileSaga(),
    analitycalDashboardSaga(),
    analitycalPartsSaga(),
    analitycalSaga(),
    biDashboardSaga(),
    billedMonthComparativeSaga(),
    billedSaga(),
    biSellersDashboardSaga(),
    blipSaga(),
    callSaga(),
    callsSaga(),
    circularsSaga(),
    dailyEmails(),
    dailySalesSaga(),
    dashboardSaga(),
    dealershipSaga(),
    dealershipsSaga(),
    departmentSaga(),
    departmentsSaga(),
    equipmentDashboardSaga(),
    equipmentSaga(),
    equipmentsSaga(),
    equipmentsTypesSaga(),
    equipmentTypeSaga(),
    functionSaga(),
    functionsSaga(),
    helpdeskDashboardSaga(),
    ipc(),
    islands(),
    newsBoardSaga(),
    newsSingle(),
    notificationsSaga(),
    objectiveSaga(),
    objectivesSaga(),
    organogramSaga(),
    panoramasSaga(),
    pops(),
    profileSaga(),
    quizzeSaga(),
    quizzesSaga(),
    receipt(),
    rhDashboardSaga(),
    rhMonthComparativeSaga(),
    salesGoalsSaga(),
    sellersSaga(),
    sessionSaga(),
    statusListSaga(),
    statusSaga(),
    superiorSaga(),
    superiorsSaga(),
    surveysSaga(),
    userSaga(),
    usersRamal(),
    usersSaga(),
  ])
}
